export enum SportDetailInputType {
  Select = 'select',
  Number = 'number',
}
